import { createSelector } from 'reselect'

import { generateUUID } from '../../utils'

export default ({ getFeatureRoot }) => {
  const getHandouts = (state) => getFeatureRoot(state).handouts
  const getProgressFiles = (state) => getFeatureRoot(state).filesInProgress

  const getHandoutsAndProgressFiles = createSelector(
    [getHandouts, getProgressFiles],
    (handouts, filesInProgress) => {
      // [...filesInProgress.values()] js Map values() not supported in IE11
      const progressFiles = []
      filesInProgress.forEach((file) => {
        progressFiles.push({
          status: 'uploading',
          name: file.name,
          percent: file.percent,
        })
      })

      return [...handouts, ...progressFiles]
    }
  )

  const getHandoutsForUploader = createSelector(
    [getHandoutsAndProgressFiles],
    (handouts) => {
      return handouts.map((handout) => ({
        uid: generateUUID(),
        name: handout.filename || handout.name,
        url: handout.url,
        status: handout.status || 'done',
        iconName: handout.icon_name || 'generic',
        percent: handout.percent,
        downloadCount: handout.download_count_fmt || '0',
      }))
    }
  )

  return {
    getHandoutsForUploader,
  }
}
